import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DateComponent } from '@app/blocks/ui/controls/date/date.component';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-field-datepicker',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyModule,
        DateComponent
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    template: `
            <div [formGroup]="form" [id]="field.id" [class]="'form-group form-group--triple schema-form-datepicker has-feedback ' + props['htmlClass']"
                [class.has-success]="formControl.status === 'VALID'" [class.has-error]="formControl.status === 'INVALID'">
                <label class="control-label" [for]="field.key.toString().slice(-1)[0]">{{props['title']}}</label>
                <p *ngIf="props['description']">{{props['description']}}</p>
                <div class="has-feedback">
                    <app-date
                        [props]="props"
                        [name]="field.key.toString().slice(-1)[0]"
                        [id]="field.key.toString().slice(-1)[0]"
                        [formControl]="formControl"
                        >
                    </app-date>
                    <ng-container *ngIf="formControl.errors === null">
                        <i class="fa fa-check-circle-o form-control-feedback" aria-hidden="true"></i>
                    </ng-container>
                    <ng-container *ngIf="formControl.errors !== null">
                        <ng-container  *ngIf="formControl.errors['length'] > 0">
                            <i class="fa fa-times-circle-o form-control-feedback" aria-hidden="true"></i>
                            <div *ngFor="let error of formControl.errors" class="help-block">
                                <div *ngIf="error === 'required' && formControl.errors['length'] === 1">Required</div>
                                <div *ngIf="error === 'dateInvalid'">Please enter a valid date</div>
                                <div *ngIf="error === 'meetsMaxAge'">You must be less than or equal to {{props['maxAge']}} years old</div>
                                <div *ngIf="error === 'meetsMinAge'">You must be at least {{props['minAge']}} years old</div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
  `
})
export class DateFieldTypeComponent extends FieldType<FieldTypeConfig> {
}
